// What the two Razor pages used to carry as inline script. Everything the page needs about itself is in
// the hidden inputs it renders, so this file reads the DOM instead of taking Razor values as arguments.
function InitPage(): void {
    InitializeParticipant(ById<HTMLInputElement>("participantPrimaryColor").value);
    InitTrackers(ParticipantName());
    InitMoodPlayer(MoodPlayerBaseUrl(), RoomKey());
    StartRoundFeed();

    window.history.pushState('', '', '/Index?roomKey=' + encodeURIComponent(RoomKey()));
}

function MoodPlayerBaseUrl(): string {
    const input = TryById<HTMLInputElement>("moodPlayerBaseUrl");
    return input ? input.value : "";
}

// The slug comes out of the room rather than from the post, so a name that is already at the table hands
// you the monster that is there instead of a slug for a monster that was never added.
function AddMonster(): void {
    const newMonsterName = prompt("Please enter a monster name:");
    if (!newMonsterName) {
        return;
    }

    PostRoundWrite("member:new", "/Participant/JoinMonster", {
        name: newMonsterName,
        roomKey: RoomKey()
    }).done(function (round: RoundResponse) {
        const monster = round.monsters.find(x => x.name.toLowerCase() === newMonsterName.toLowerCase());
        if (monster) {
            AddInitiativeSelection(monster.nameSluggified, newMonsterName);
        }
    });
}

function NextRound(): void {
    PostRoundAction("NewRound");
}

function ResetRound(): void {
    if (!confirm("Weet je zeker dat je deze ronde wil resetten?")) {
        return;
    }

    PostRoundAction("ResetRound");
}

function ResetGame(): void {
    if (!confirm("Weet je zeker dat je ALLES wil resetten?")) {
        return;
    }

    PostRoundAction("ResetGame").done(function () {
        window.location.reload();
    });
}

function PostRoundAction(action: string): JQuery.jqXHR {
    return PostRoundWrite("round:" + action, "/Round/" + action, { roomKey: RoomKey() });
}
